import { useEffect, useState, useCallback } from "react";
import { Collection } from "@/types";
import { api } from "@/services/api";
import { toast } from "@/components/ui/sonner";

declare global {
  interface Window {
    chrome: typeof chrome;
  }
}

export function useCollections() {
  const [collections, setCollectionsState] = useState<Collection[]>([]);
  const [loading, setLoading] = useState(true);

  const fetchCollections = useCallback(async () => {
    try {
      const response = await api.getCollections();
      setCollectionsState(response.data);
    } catch (error) {
      toast.error(error instanceof Error ? error.message : 'Failed to fetch collections');
      setCollectionsState([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchCollections();
  }, [fetchCollections]);

  const setCollections = useCallback(async (newCollections: Collection[]) => {
    try {
      setCollectionsState(newCollections);
    } catch (error) {
      toast.error(error instanceof Error ? error.message : 'Failed to update collections');
    }
  }, []);

  return [collections, setCollections, loading] as const;
} 